const neighborhoodResources = {
  en: {
    neighborhood: {
      title: 'Neighbor liability insurance',
      calculator: 'Insurance Calculator',
      'description.title': 'Description',
      'description.text':
        'Would you like to maintain good relations with your neighbors? "Alatau City Garant" offers you a liability insurance program to neighbors "Neighbours". Unforeseen situations: flood or fire damage not only your apartment, but also your neighbors? The presence of the "Neighbors" policy will help you to repair the damage to your neighbors as soon as possible: restore their repairs and property, as well as maintain excellent relations!',
      'description.text.small':
        'Unforeseen situations: flood or fire damage not only your apartment, but also your neighbors? The presence of the "Neighbors" policy will help you to repair the damage to your neighbors as soon as possible: restore their repairs and property, as well as maintain excellent relations!',
      'description.text1': 'Policyholders – ',
      'description.text2': 'individuals (owners of residential real estate)',
      'description.text3': 'Insured persons – ',
      'description.text4': 'persons living in a residential building',
      'description.text5': 'Type of property ',
      'description.text6': 'accepted for insurance – apartment, house',
      'description.text7': 'An insured event ',
      'description.text8':
        'is the fact of the occurrence of civil liability of the policyholder (insured), for obligations arising as a result of damage to the property of third parties during the operation of residential premises due to:',
      'description.text9':
        'Damage to water supply, sewerage, heating systems, sprinkler fire extinguishing system;',
      'description.text10':
        'Explosion, fire (including the consequences of fire extinguishing).',
      'description.text11': 'Insurance amount:',
      'description.text12': 'Minimum – 300,000 (three hundred thousand) tenge',
      'description.text13': 'Maximum - 3,000,000 (three million) tenge',
      'description.text14': 'Tariff: ',
      'description.text15': 'from 0.8%',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016%D1%85158_en8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_en8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016%D1%85158_B_en8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_B_en8.png',
      },
    },
  },
  kz: {
    neighborhood: {
      title: 'Көршілер алдындағы жауапкершілікті сақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text':
        'Көршілермен жақсы қарым-қатынасты сақтағыңыз келе ме? «Alatau City Garant» Сізге  көршілер алдындағы жауапкершілікті сақтандырудың «Көршілер» бағдарламасын ұсынады. Күтпеген жағдайлар: су немесе өрт сіздің пәтеріңізге ғана емес, көршілеріңізге де зиян тигізе ме? «Көршілер» полисінің болуы көршілеріңізге мүмкіндігінше қысқа мерзімде өтемақы төлеуге көмектеседі: олардың жөндеуі мен мүлкін қалпына келтіру, сондай-ақ тамаша қарым-қатынасты сақтау!',
      'description.text.small':
        'Күтпеген жағдайлар: су немесе өрт сіздің пәтеріңізге ғана емес, көршілеріңізге де зиян тигізе ме? «Көршілер» полисінің болуы көршілеріңізге мүмкіндігінше қысқа мерзімде өтемақы төлеуге көмектеседі: олардың жөндеуі мен мүлкін қалпына келтіру, сондай-ақ тамаша қарым-қатынасты сақтау!',
      'description.text1': 'Сақтанушылар - ',
      'description.text2': 'жеке тұлғалар (тұрғын үй мүлік иелері)',
      'description.text3': 'Сақтандырылғандар - ',
      'description.text4': 'тұрғын үйде тұратын адамдар',
      'description.text5':
        'Сақтандыруға қабылданатын жылжымайтын мүлік түрі - ',
      'description.text6': 'пәтер, жер үй',
      'description.text7': 'Сақтандыру жағдайы - ',
      'description.text8':
        'тұрғын үйді пайдалану кезінде үшінші тұлғалардың мүлкіне зиян келтіру нәтижесінде туындайтын міндеттемелер бойынша сақтанушының (сақтандырылушының) азаматтық-құқықтық жауапкершілігінің басталу фактісі:',
      'description.text9':
        'Су құбыры, кәріз, жылыту жүйелерімен, өрт сөндірудің спринклер жүйесімен залал келтіру;',
      'description.text10': 'Жарылыс, өрт (өрт сөндіру салдарын қоса алғанда).',
      'description.text11': 'Сақтандыру сомасы: ',
      'description.text12': 'Ең төмен - 300 000 (үш жүз мың) теңге',
      'description.text13': 'Ең жоғары - 3 000 000 (үш миллион) теңге',
      'description.text14': 'Тариф: ',
      'description.text15': '0,8% бастап',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016%D1%85158_kz8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_kz8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016%D1%85158_B_kz8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_B_kz8.png',
      },
    },
  },
  ru: {
    neighborhood: {
      title: 'Страхование ответственности перед соседями',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text':
        'Желаете сохранить хорошие отношения с соседями? «Alatau City Garant» предлагает вам программу страхования ответственности перед соседями «Соседи». Непредвиденные ситуации: залив водой или пожар наносят ущерб не только вашей квартире, но и соседям? Наличие полиса «Соседи» поможет вам в максимально короткие сроки возместить ущерб соседям: восстановить их ремонт и имущество, а также сохранить отличные отношения!',
      'description.text.small':
        'Непредвиденные ситуации: залив водой или пожар наносят ущерб не только вашей квартире, но и соседям? Наличие полиса «Соседи» поможет вам в максимально короткие сроки возместить ущерб соседям: восстановить их ремонт и имущество, а также сохранить отличные отношения!',
      'description.text1': 'Страхователи – ',
      'description.text2': 'физические лица (владельцы жилой недвижимости)',
      'description.text3': 'Застрахованные – ',
      'description.text4': 'лица, проживающие в жилом помещении',
      'description.text5': 'Тип принимаемой на страхование недвижимости – ',
      'description.text6': 'квартира, дом',
      'description.text7': 'Страховой случай – ',
      'description.text8':
        'факт наступления гражданско-правовой ответственности страхователя (застрахованного), по обязательствам, возникающим в результате причинения вреда имуществу третьих лиц при эксплуатации жилого помещения вследствие:',
      'description.text9':
        'Нанесение ущерба водопроводной, канализационной, отопительной системами, спринклерной системой пожаротушения;',
      'description.text10':
        'Взрыва, пожара (включая последствия пожаротушения).',
      'description.text11': 'Страховая сумма: ',
      'description.text12': 'Минимальная – 300 000 (триста тысяч) тенге',
      'description.text13': 'Максимальная – 3 000 000 (три миллиона) тенге ',
      'description.text14': 'Тариф: ',
      'description.text15': 'от 0,8% ',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016х158_ru8.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_ru8.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_2016х158_B_ru8.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/PROPERTY_343x100_B_ru8%20.png',
      },
    },
  },
};

export default neighborhoodResources;
